module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/confirmView.html -->\n<article class="content content--modal scrollable '+
((__t=( classes ))==null?'':_.escape(__t))+
'">\n	<p class="mdc-typography--body1">'+
((__t=( message.format(itemLabel) ))==null?'':__t)+
'</hp>\n</article>\n\n<footer class="footer footer--modal">\n	<div class="footer-actions">\n		';
 if (noLabel) { 
__p+='\n		<button type="button" class="mdc-button cancel nx-cancel" data-nx-control="no">'+
((__t=( noLabel ))==null?'':_.escape(__t))+
'</button>\n		';
 } 
__p+='\n	</div>\n	<div class="footer-actions footer-actions--right">\n		';
 if (yesLabel) { 
__p+='\n		<button type="submit" class="mdc-button mdc-button--unelevated submit nx-save" data-nx-control="yes">'+
((__t=( yesLabel ))==null?'':_.escape(__t))+
'</button>\n		';
 } 
__p+='\n	</div>\n</footer>\n';
}
return __p;
};
